module.exports = __webpack_public_path__ + "static/media/failure.b73914a3.png";